module.exports = __webpack_public_path__ + "img/home-pencil-icon.a69379c1.png";